import { createFileRoute } from "@tanstack/react-router";
import { InboxPage } from "@/components/inbox";

export const Route = createFileRoute("/$workspaceSlug/inbox")({
  component: InboxPage,
});
